import { useQuery } from "@tanstack/react-query";
import { getBrand } from "src/api/brand";
import { QUERY_KEYS } from "../constants/queryKeys";
export const useBrandQuery = (param)=>{
    let { name , initialData  } = param;
    return useQuery({
        queryKey: QUERY_KEYS.BRAND(name),
        queryFn: ()=>getBrand(name),
        initialData,
        enabled: !!name
    });
};
